import { Restaurant } from '../types'

/**
 * Returns whether a restaurant is currently open based on its schedule.
 * Times are evaluated in the Trinidad & Tobago timezone (America/Port_of_Spain).
 */
export function isRestaurantOpen(restaurant: Restaurant): boolean {
  const now = new Date()
  const currentDay = now
    .toLocaleDateString('en-US', { weekday: 'long', timeZone: 'America/Port_of_Spain' })
    .toLowerCase()
  const currentTime = now.toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'America/Port_of_Spain',
  })

  const isClosedToday = restaurant[`${currentDay}_is_closed` as keyof Restaurant] as boolean
  const openTime = restaurant[`${currentDay}_open` as keyof Restaurant] as string | undefined
  const closeTime = restaurant[`${currentDay}_close` as keyof Restaurant] as string | undefined

  if (!isClosedToday && openTime && closeTime) {
    return currentTime >= openTime && currentTime <= closeTime
  }
  return false
}
